import React from 'react';
import { ContractorActivity, IConnectGetQuery } from '../../types';
import { API, graphqlOperation } from 'aws-amplify';
import Loader from '../../Components/Loader';
import { message } from 'antd';
import ContractorActivityForm from './partials/ActivityForm';
import { CreateContractorActivityInput } from '../../API';
import { createContractorActivity, deleteContractorActivity, updateContractorActivity } from '../../graphql/mutations';
import mixpanel from 'mixpanel-browser';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import moment from 'moment';

type Props = IAppStateComponentProps & {
  close: () => void;
  onSave?: () => void;
  record: ContractorActivity;
  timesheetId: string;
};
type State = {
  activity?: ContractorActivity | null;
  loading: boolean;
};
class ActivityConnectedForm extends React.Component<Props, State> {
  state = {
    activity: null,
    loading: false,
  };
  async componentDidMount(): Promise<void> {
    if (this.props.record) {
      // We should load from the API
      try {
        this.setState({
          activity: this.props.record,
          loading: false,
        });

        mixpanel.track('View Contractor Activity', {
          activityId: this.props.record.id,
        });
      } catch (e) {
        message.error('Contractor Activity not found');
        this.props.close();
      }
    }
  }

  render(): React.ReactElement {
    if (this.state.loading) {
      return <Loader />;
    }
    if (this.state.activity) {
      return <ContractorActivityForm record={this.state.activity} close={this.props.close} />;
    }
    return <Loader />;
  }
}

export default withAppState(ActivityConnectedForm);
